package fr.frux.core.designsystem.layout

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.unit.dp

/**
 * Bords de la zone carte recouverts par le chrome racine (spec 2026-09-10 §5, « cadrage caméra à
 * quatre côtés ») : le bas par la barre du bas en mode compact, le début par la colonne de
 * `MapZone` en grand écran. Posé par le squelette racine autour de la carte persistante et de la
 * pile. Généralise `LocalBottomNavPadding`, qui reste le dégagement des onglets ordinaires.
 *
 * Vaut zéro par défaut (aperçus, tests) : un composable sans provider explicite ne réserve rien.
 *
 * `compositionLocalOf` et non `staticCompositionLocalOf` : la carte persistante est composée sous
 * ce provider (ADR 0009). Un local statique invaliderait toute la surface carte à chaque
 * changement de dégagement, alors que seul le nœud feuille qui le lit doit recomposer.
 */
val LocalRootChromeInsets = compositionLocalOf { PaddingValues(0.dp) }
